import React, { FC, useEffect, useMemo, useState } from 'react';
import { Button, Input, TextArea, Select } from '@scuf/common';
import { useAppDispatch } from 'src/store';
import { toast, Zoom } from 'react-toastify';
import { Snackbar } from 'src/components/Snackbar/Snackbar';
import { updateModelName, getModalNameUpdateLoading } from 'src/slices/contextSlice';
import { getAllDomainDetails } from 'src/slices/onBoardingSlice';
import { useSelector } from 'react-redux';
import { checkSpecialCharacters } from 'src/utils/validationUtils';

type IDomains = {
    value: number,
    text: string
}

type Domains = Array<IDomains>

export const StageOne: FC<{ header: string, modelData?: any, refreshEditScreen: Function, handleClose: Function, createNewModel: Boolean }> = ({ header, modelData, refreshEditScreen, handleClose, createNewModel }) => {
    const dispatch = useAppDispatch();

    const [newModelName, setNewModelName] = useState<string>("");
    const [newModelSummayText, setNewModelSummayText] = useState<string>("");
    const [domain, setDomain] = useState<string>('');
    const [validationError, setValidationError] = useState<boolean>(false);
    const [validationErrorDescription, setValidationErrorDescription] = useState<boolean>(false);

    const master_domain = useSelector(getAllDomainDetails)
    const domains: Domains = master_domain.map(( item: any ) => {
        return{
            'value' : item.domain_id,
            'text' : item.domain_name
        }     
    })
    const handleModelName = (modelName: string) => {
         if(checkSpecialCharacters(modelName)) {
                    setValidationError(true);
                } else {
                    setValidationError(false);
                    setNewModelName(modelName);
                }
    }

    const handleModelSummaryText = (modelSummaryText: string) => {
        if(checkSpecialCharacters(modelSummaryText)) {
            setValidationErrorDescription(true);
        } else {
            setValidationErrorDescription(false);
            setNewModelSummayText(modelSummaryText);
        }
    }

    const editLoading = useSelector(getModalNameUpdateLoading);

    const disableButton = useMemo(
        () =>
          [
            newModelName ?? '',
            domain ?? '',
            
          ]
            .flat()
            .some((data) => [null, '', undefined].includes(data.toString())),
            // .some(data => console.log(data)),
        [newModelName, domain]
      );

    const onUpdateModel = () => {
        if (disableButton) return;
        let modelRenamePostData: any = {}
            if(!createNewModel){
                modelRenamePostData = {
                    model_id: modelData[0].model_id,
                    module_id: modelData[0].module_id,
                    model_name: newModelName,
                    model_summary_text: newModelSummayText,
                    is_new: false,
                }
            }
        let modelNewModelData = {
            // model_id: modelData.model_details[0].model_id,
            module_id: domain,
            model_name: newModelName,
            model_summary_text: newModelSummayText,
            is_new: true,
        };
        if (createNewModel) {
            modelRenamePostData = modelNewModelData;
        }
        dispatch(updateModelName(modelRenamePostData)).then((response: any) => {
            if(response.meta.requestStatus === 'fulfilled'){
                toast(<Snackbar toastMessage={createNewModel ? "Model Created Successfully " : "Model Renamed Successfully"} />, {
                    position: 'bottom-right',
                    className: 'fi-toast--snackbar',
                    bodyClassName: 'fi-toast__body--snackbar',
                    transition: Zoom,
                    closeOnClick: true,
                });
                if (createNewModel) {
                    handleClose();
                } else refreshEditScreen();
            }
            else{
                toast(<Snackbar toastMessage={'Something went wrong, please try again!'} />, {
                    position: 'bottom-right',
                    className: 'fi-toast--snackbar',
                    bodyClassName: 'fi-toast__body--snackbar',
                    transition: Zoom,
                    closeOnClick: true,
                });
            }
            }).catch(() => {
                toast(<Snackbar toastMessage={"Model Rename Failed"} />, {
                    position: 'bottom-right',
                    className: 'fi-toast--snackbar',
                    bodyClassName: 'fi-toast__body--snackbar',
                    transition: Zoom,
                    closeOnClick: true,
                });
                

        });
    }

    // useEffect(() => {
    //     setNewModelName(modelData[0].model_name)
    //     setNewModelSummayText(modelData[0].model_summary_text)
    // }, []);


    useEffect(() => {
        if (createNewModel) {
            setNewModelName("")
            setNewModelSummayText("")
            setDomain('')
        } else {
            setNewModelName(modelData[0].model_name)
            setNewModelSummayText(modelData[0].model_summary_text)
            setDomain(modelData[0].module_id)
        }

    }, [createNewModel]);

    

    return (
        <div className='right-container'>
            <div className='right-container-step-one'>
                {/* <Button
                    className='context-edit-btn custom-btn create-model'
                    content={createNewModel?'Cancel Create Model':'Create New Model'}
                    size='small'
                    textTransform={false}
                    onClick={() => setCreateNewModel(!createNewModel)}
                ></Button> */}
                <div className='editable-text'>
                    {<Input placeholder="Model Name" label="Model Name" className='custom-input'
                        value={newModelName ?? ''}
                        onChange={(value: any) => handleModelName(value)}
                    />
                    }
                    {validationError && <div className="action--error-text">Special characters not allowed.</div>}

                </div>
                {!createNewModel &&
                    <div className='editable-text'>
                        <Input placeholder="Domain" label="Domain" className='custom-input'
                            value={modelData? modelData[0]?.module_name : ''}
                            disabled
                        />
                    </div>
                }
                {createNewModel && 
                    <div>
                        <Select
                            label='Domain'
                            options={domains}
                            onChange={(e) => setDomain(e)}
                            defaultValue={domains.length===1? domains[0].value : domain}   
                            value={domain}                                                       
                        />
                    </div>                  
                }


                {/* <Input placeholder="Model Summary Text"  label="Model Summary Text" /> */}
                <div className='editable-text'>
                    <label className="label">
                        {"Model Summary Text"}
                    </label>
                    <TextArea
                        // onChange={(value: any) => handleTextbox(value)}
                        // className="textarea-wrapper textarea-fi accept-gap"
                        onChange={(value: any) => handleModelSummaryText(value)}

                        fluid={true}
                        rows={1}
                        value={newModelSummayText}
                    />
                </div>
                {validationErrorDescription && <div className="action--error-text">Special characters not allowed.</div>}
                <div>
                </div>
                <div className='right-container-step-one-footer'>
                    <Button
                        className='action-btn custom-btn'
                        size='small'
                        type='secondary'
                        textTransform={false}
                        content='Cancel'
                        onClick={() => handleClose()}
                    />
                    <Button
                        className='action-btn custom-btn'
                        size='small'
                        textTransform={false}
                        disabled={disableButton || editLoading}
                        loading={editLoading}
                        onClick={() => onUpdateModel()}
                        content={createNewModel? 'Create' : 'Update'}
                    />

                </div>
            </div>
        </div>



    );
};

export default StageOne;